import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class WarningDialog extends Component {
    constructor(props) {
        super(props)
        this.state= {
            
        }
    }

    getTitle=()=>{
        switch(this.props.from)
        {
            case "SignIn" :
                return "您是此帳號所有者嗎本人嗎?"
            case "EventListBody" :
                return "您確定要刪除此專題嗎?"
            case "MovieMountStatusChange":
                return "您確定要變更上下架狀態?"
            case "MovieSessionOccupied":
                return "您不能操作上下架!"
            default :
                return null
        }
       
    }

    getContentText=()=>{
        let warningNumber = {
            color:"#fc0313"
        } 

        switch(this.props.from)
        {
            case "SignIn" :
                return  <div>此帳號驗證錯誤已超過<span style={warningNumber}>3次</span>，系統已上鎖此帳號。若您是此帳號所有人，請通知管理人員處理。</div>
            case "EventListBody" :
                return "刪除專題後，資料將不可回復。您確定要刪除此專題嗎?"
            case "MovieMountStatusChange":
                return this.getMovieMountStatusChangeContext()    
            case "MovieSessionOccupied":
                return "目前有其他使用者正在操作電影作品資料上下架，在該使用者結束操作前，您不能操作資料上下架!"     
            default :
                return null
        }
    }

    getConfirmButtonText=()=>{
        switch(this.props.from)
        {
            case "SignIn" :
                return "帳號已上鎖"
            case "EventListBody" :
                return "刪除"
            case "MovieMountStatusChange":
                return this.props.msg && this.props.msg.Movie_Mount === 0 ? "上架":"下架"
            case "MovieSessionOccupied":
                return "了解"
            default :
                return null
        }
    }

    showCancelButtonOrNot=()=>{
        switch(this.props.from)
        {
            case "SignIn" :
                return null
            case "EventListBody" :
                return <Button onClick={this.props.cancel} color="primary">取消</Button>
            case "MovieMountStatusChange" :
                return <Button onClick={this.props.cancel} color="primary">取消</Button>
            case "MovieSessionOccupied":
                return null
            default :
                return null
        }
    }

    getMovieMountStatusChangeContext=()=>{
        let warningNumber = {
            color:"#fc0313"
        } 
        let msg
        if(this.props.msg && this.props.msg.Movie_Mount === 0)
        {
            msg = "上架"
        }
        else
        {
            msg = "下架"
        }
        return <div>您確定要變更電影作品<span style={warningNumber}>{this.props.msg && this.props.msg.Movie_SysID ? this.props.msg.Movie_SysID:""}</span>為<span style={warningNumber}>{msg}</span>狀態?</div>
    }

    render(){
       


        return(
            <div>
                <Dialog open={this.props.showWarningDialog} onClose={this.props.cancel} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{this.getTitle()}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.getContentText()}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.confirm} color="primary">
                            {this.getConfirmButtonText()}
                        </Button>
                        {this.showCancelButtonOrNot()}
                    </DialogActions>
                </Dialog>
            </div>
        )

    }

}

export default WarningDialog


